import React from "react";

function useWhyDidYouUpdate(name: string, props: { [k: string]: unknown }) {
  const previousProps = React.useRef<{ [k: string]: unknown }>();

  React.useEffect(() => {
    const previous = previousProps.current;
    if (previous) {
      // Get all keys from previous and current props
      const allKeys = Object.keys({ ...previous, ...props });
      // Use this object to keep track of changed props
      const changesObj: { [k: string]: unknown } = {};
      // Iterate through keys
      for (const key of allKeys) {
        // If previous is different from current
        if (previous[key] !== props[key]) {
          // Add to changesObj
          changesObj[key] = {
            from: previous[key],
            to: props[key],
          };
        }
      }

      // If changesObj not empty then output to console
      if (Object.keys(changesObj).length) {
        // eslint-disable-next-line no-console
        console.log("[why-did-you-update]", name, changesObj);
      }
    }

    // Finally update previousProps with current props for next hook call
    previousProps.current = props;
  });
}

export default useWhyDidYouUpdate;
